import styled from "styled-components";
import { keyframes } from "@emotion/react";

export const WhyBlockSection = styled("section")`
  position: relative;
  padding-top: 6rem;
  padding-bottom: 6rem;
  z-index: 2;
    overflow: hidden;

  @media screen and (max-width: 1024px) {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }
`;
export const ContentWrapper = styled("div")`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  max-width: 1140px;
  width: 100%;

  @media only screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;

    & > .left-column {
      padding: 0 10px;
      width: 100%;
      position: relative;
      min-height: 500px; 
    }
  }
`;


export const CoreTitle = styled("h6")`
  font-size: 45px;
  line-height: 1rem;
  padding: 0.8rem 0 3rem 0;
  color: #2159A6;
  font-family: "Gilroy Bold", sans-serif;

  @media screen and (max-width: 768px) {
  font-size: 30px;
  padding: 0.5rem 0 2rem 0;
  text-align: center;
  }
`;

export const Header = styled("h6")`
  font-size: 20px;
  line-height: 1rem;
  color: #2A3273;
  font-family: "Gilroy Bold", sans-serif;

  @media screen and (max-width: 768px) {
  font-size: 18px;
  text-align: center;
  }
`;

export const CenterWrapper = styled.div`
  padding: 0 1rem;
  max-width: 900px;
  margin: 0 auto;
  text-align: left;

  @media screen and (max-width: 1024px) {

  }

  @media screen and (max-width: 768px) {

  }

  @media screen and (max-width: 480px) {
      text-align: left;
      max-width: 300px;
  }

  @media screen and (max-width: 344px) {
      text-align: left;
      max-width: 300px;
  }
`;

export const MinKeywords = styled("p")`
  font-size: 24px;
  line-height: 1.5rem;
  color: #2159A6;
  font-family: "Gilroy Semibold", sans-serif;
  text-align: left;
  padding: 0 4rem;

  @media screen and (max-width: 768px) {
    font-size: 16px;
    line-height: 1.1rem;
    padding: 0 1rem;
    text-align: left;
  }

  @media screen and (max-width: 480px) {
    font-size: 18px;
    padding: 0 0.5rem;
  }
`;

export const MinPara = styled("p")`
  font-size: 18px;
  line-height: 1.5rem;
  color: #000000;
  font-family: "Gilroy Light", sans-serif;
  text-align: left;
  max-width: 950px;
  padding: 0 4rem;

  @media screen and (max-width: 768px) {
    font-size: 16px;
    line-height: 1.1rem;
    padding: 0 1rem;
    max-width: 100%;
  }

  @media screen and (max-width: 480px) {
    font-size: 14px;
    padding: 0 0.5rem;
  }
`;

export const StyledImage = styled.img`
  position: relative;
  width: 100%;
  max-width: 100px;
  height: auto;

  
  @media (max-width: 768px) {
    position: relative;
    width: 90%;
    max-width: 100px;
    height: auto;
    padding: 1rem 0;
  }
`;

export const SemicircleRectangle = styled.div`
  position: relative;
  width: 220px;
  height: 220px;
  background-color: #2A3273;
  border-top-left-radius: 0;
  border-top-right-radius: 150px;
  border-bottom-right-radius: 150px;
  border-bottom-left-radius: 0;
  overflow: visible;

  &::after {
    content: '';
    position: absolute;
    bottom: -50px;
    left: 0px;
    width: 100px;
    height: 120px;
    background-color: #2159A6;
    border-top-left-radius: 0;
    border-top-right-radius: 90px;
    border-bottom-right-radius: 90px;
    border-bottom-left-radius: 0;
  }

  @media only screen and (max-width: 845px) {
    width: 100px;
    height: 110px;

    &::after {
      width: 60px;
      height: 60px;
      bottom: -20px;
    }
  }
`;

export const TopHalfSemicircleRectangle = styled.div`
   position: absolute;
  left: 0;
  width: 60px;
  height: 180px;
  top: 40px;
  background-color: #2159A6;
  border-top-left-radius: 0;
  border-top-right-radius: 90px;
  border-bottom-right-radius: 90px;
  border-bottom-left-radius: 0;
  overflow: visible;

  @media only screen and (max-width: 1024px) {
    width: 40px;

    &::after {
      width: 90px;
      height: 60px;
      bottom: -15px;
      left: -20px;
    }
  }

  @media only screen and (max-width: 845px) {
    width: 40px;
    height: 110px;
    top: 0px;
    &::after {
      width: 90px;
      height: 60px;
      bottom: -15px;
      left: -20px;
    }
  }
`;

export const DividerLine = styled.div`
  height: 1px;
  width: 70%;
  background-color: #d3d3d3;
  margin: 1rem auto;

  @media screen and (max-width: 1024px) {

  }

  @media screen and (max-width: 768px) {

  }

  @media screen and (max-width: 480px) {
      height: 1px;
      width: 90%;
      background-color: #d3d3d3;
      margin: 6px auto;
  }

  @media screen and (max-width: 344px) {
      height: 1px;
      width: 80%;
      background-color: #d3d3d3;
      margin: 2px auto;
  }

`;

export const FourPetalFlower = styled.div`
  position: absolute;
  width: 220px;
  height: 220px;
  right: -100px;
  top: 540px;
  margin: 0 auto;
  z-index: 1;

  &::before,
  &::after,
  .petal-horizontal,
  .petal-vertical {
    content: '';
    position: absolute;
    width: 110px;
    height: 110px;
    background-color: #2A3273;
    border-radius: 50%;
  }

  &::before {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  &::after {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .petal-horizontal {
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }

  .petal-vertical {
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }

  @media screen and (max-width: 1024px) {
    width: 150px;
    height: 150px;
    top: 400px;
    right: -75px;

    &::before,
    &::after,
    .petal-horizontal,
    .petal-vertical {
      width: 80px;
      height: 80px;
    }
  }

  @media screen and (max-width: 845px) {
    width: 100px;
    height: 100px;
    top: 350px;
    right: -50px;

    &::before,
    &::after,
    .petal-horizontal,
    .petal-vertical {
      width: 50px;
      height: 50px;
    }
  }
`;

export const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(40px);
    visibility: hidden;
  }
  to {
    opacity: 1;
    transform: translateY(0);
    visibility: visible;
  }
`;